import $ from "jquery";

export const formActions = () => {

  const checkboxes = document.querySelectorAll('.mc4wp-checkbox input[type="checkbox"]');

  checkboxes.forEach(checkbox => checkbox.addEventListener('change', function () {
      if (this.checked) {
        this.parentElement.classList.add('checked');
        return;
      }

      this.parentElement.classList.remove('checked');
    }))

  window.addEventListener('message', function(event) {
    // Check if the message is from HubSpot
    if (event.data.eventName === 'onFormReady') {
      floatingFormSize();
    }

    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        if(!wpApiSettings.currentPostId) {
          return;
        }

      // AJAX call to WordPress to set the session
      $.ajax({
        type: "POST",
        url: wpApiSettings.ajaxUrl, // Use wpApiSettings to get the right URL
        data: {
          action: 'set_hubspot_session',
          formValue: 'Form Submitted', // Or any other value you need to pass
          nonce: wpApiSettings.nonce, // Send nonce for security, passed from wp_localize_script
          postId: wpApiSettings.currentPostId,
        },
        success: function(response) {
          var data = JSON.parse(response);
          if (data.status === 'success') {
            if($('.register-popup').length) {
              $('.register-popup').addClass('visible');
            } else {
              setTimeout(() => window.location.reload(), 3000);
            }
          }
        }
      });
    }
  });
}

export const floatingFormSize = () => {
  const setHeight = () => {
    const maxRowsHeight = window.innerWidth <= 980 ? 6 : 16;

    const floatingForm = document.querySelector('.floating-form');
    if (floatingForm) {
      const parent = floatingForm.parentElement;
      const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const maxSubtract = Math.min(remInPx * maxRowsHeight, floatingForm.offsetHeight * 0.5);

      const height = floatingForm.offsetHeight - maxSubtract;
      parent.style.height = `${height}px`;
    }
  }

  window.addEventListener('resize', setHeight);
  setHeight();
};
